export const urlEncodingDynamicValueModeEncode = 0
export const urlEncodingDynamicValueModeDecode = 1
